import { Provider } from "components/user-qrcode/UserQrCodeContext";
import { UserQrCodeList } from 'components/user-qrcode/UserQrCodeList';

export const UserQrcodes = () => {
    return (
        <Provider>
            <UserQrCodeList />
        </Provider>
    );
};
